import { Injectable } from '@angular/core';
import { ApiService, IApiOption } from '@red/api';
import { PaginationAdapter } from '@red/data-access';
import { NoReminderCreateDto, NoReminderUpdateDto } from '@shared/data-access/dto';
import { NoReminderModel } from '@shared/data-access/models';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NoReminderApiService {
  static ROOT_POINT = 'storage/no-reminders';

  constructor(private apiService: ApiService) { }

  search(query = {}, option?: IApiOption): Observable<PaginationAdapter<NoReminderModel>> {
    return this.apiService
      .get(NoReminderApiService.ROOT_POINT, query, { ...option, removeEmpty: { enable: true } })
      .pipe(map(data => new PaginationAdapter(NoReminderModel, data)));
  }

  create(data: NoReminderCreateDto): Observable<NoReminderModel> {
    return this.apiService.post(NoReminderApiService.ROOT_POINT, data).pipe(map(res => NoReminderModel.fromJson(res) as NoReminderModel));
  }

  update(id: number, data: NoReminderUpdateDto): Observable<unknown> {
    return this.apiService.patch(`${NoReminderApiService.ROOT_POINT}/${id}`, data);
  }

  delete(id: number, option?: IApiOption): Observable<unknown> {
    return this.apiService.delete(`${NoReminderApiService.ROOT_POINT}/${id}`, {}, option);
  }
}
